export const RULE_LOOKBACK_DAYS_DEFAULT = 90;
export const RULE_LOOKBACK_DAYS_MAX = 365;
export const RULE_REFRESH_DAYS_MAX = 21;
export const SEARCH_TERM_PLACEHOLDER = 'chai';

export const CART_ADDERS_QUERY = `/* Audience Exploratory Query: Added to cart but did not purchase */
-- Optional update: To filter by ASINs, add one or more ASINs to the list of ASINs below and uncomment lines [1 of 2] and [2 of 2]
WITH
  asins (asin) AS (
    VALUES
      /* Optional update: Populate the list of ASINs below to filter by ASINs */
      ('asin1'),
      ('asin2')
  ),
  purchase AS (
    SELECT
      user_id,
      max(event_dt_utc) AS purchase_dt_max
    FROM
      conversions_for_audiences
    WHERE
      event_subtype = 'order'
      /* AND tracked_item IN (SELECT asin FROM asins) -- Optional update [1 of 2]: Uncomment this line to enable ASIN filters. Leave the line commented to skip filters. */
    GROUP BY
      1
  ),
  atc AS (
    SELECT
      user_id,
      max(event_dt_utc) AS atc_dt_max
    FROM
      conversions_for_audiences
    WHERE
      event_subtype = 'shoppingCart'
      /* AND tracked_item IN ( SELECT asin FROM asins ) -- Optional update [2 of 2]: Uncomment this line to enable ASIN filters. Leave the line commented to skip filters. */
    GROUP BY
      1
  )
SELECT
  atc.user_id
FROM
  atc
  LEFT JOIN purchase ON atc.user_id = purchase.user_id
WHERE
  atc_dt_max > purchase_dt_max
  OR purchase_dt_max IS NULL`;

const SEARCH_AUDIENCE_TABLE = 'sponsored_ads_traffic_for_audiences';

export function buildSearchAudienceQuery(term: string): string {
  const escaped = term.trim().replace(/'/g, "''");
  return `SELECT user_id FROM ${SEARCH_AUDIENCE_TABLE} WHERE customer_search_term SIMILAR TO '(?i)${escaped}'`;
}

export function isPlaceholderSearchTerm(term: string): boolean {
  return term.trim().toLowerCase() === SEARCH_TERM_PLACEHOLDER;
}

export function audienceFailureCopy(reason: string | null | undefined): string | null {
  if (!reason?.toLowerCase().includes('no members')) return null;
  return "This query matched fewer than Amazon's 2,000-shopper minimum. Use a longer lookback or a broader query.";
}
